import React from 'react';
import styled from 'styled-components';

import { Flex } from 'baukasten';

import WorkpathLogo from 'components/WorkpathLogo';

import type { StarterSpec } from '../types';
import { ChatStarters } from './ChatStarters';

// the fullscreen sidebar is far wider than the composer wants to be
const Column = styled(Flex)`
  width: 100%;
  max-width: 672px;
`;

type Props = {
  starters: StarterSpec[];
  composer: React.ReactNode;
  onPick: (message: StarterSpec['message']) => void;
};

export const WelcomeState = ({ starters, composer, onPick }: Props) => (
  <Column col gap={5}>
    <Flex justifyContent="center">
      <WorkpathLogo height={40} />
    </Flex>
    {composer}
    <ChatStarters starters={starters} onPick={onPick} />
  </Column>
);
